<template>
    <div class="container">
        <div class="head_bg">
            <comm-head></comm-head>
            <div class="head_con">
                <h1>联系我们</h1>
                <div></div>
            </div>
        </div>

        <div class="bg_w">
            <div>
                <h1>联系方式</h1>
                <p>地址：杭州市江干区普盛巷9号东谷创业园7-9层</p>
                <p>电话：0571-56638136</p>
                <p>邮箱：support@duomai.com</p>
                <p>公交：357/358三村社区东公交站</p>
                <p>地铁方式：地铁1号线（文泽路方向），在九和路站B1出口向前1.7公里</p>
                <h1>微信关注我们</h1>
                <div class="qrcode">
                    <div>
                        <img src="../assets/images/vx_duomai.png" alt="">
                        <p>多麦股份</p>
                    </div>
                    <div>
                        <img src="../assets/images/vx_mlh.png" alt="">
                        <p>麦乐会</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="map">
            <el-amap vid="amapDemo" :zoom="zoom" :center="center">
                <el-amap-info-window :position="mywindow.position" :content="mywindow.content" :visible="mywindow.visible" :events="mywindow.events"></el-amap-info-window>
                <el-amap-marker :position="marker.position" :events="marker.events" :visible="marker.visible" :draggable="marker.draggable"></el-amap-marker>
            </el-amap>
        </div>
        <foot-cpright></foot-cpright>
    </div>
</template>

<script>
import commHead from '@/components/comm-head.vue'
import footCpright from '@/components/foot-cpright.vue'
export default {
    data() {
        return {
            zoom: 16,
            center: [120.25188, 30.31858],
            marker: {
                position: [120.25188, 30.31858],
                visible: true,
                draggable: true
            },
            mywindow: {
                position: [120.25188, 30.31858],
                content:
                    '<h4 style="font-size: 13px;">地址：杭州市江干区普盛巷9号东谷创业园7-9层</h4>' +
                    '<div style="font-size: 13px;">电话：0571-56638596</div>' +
                    '<div style="font-size: 13px;">邮箱：support@duomai.com</div>' +
                    '<div style="font-size: 13px;">公交：357/358三村社区东公交站</div>' +
                    '<div style="font-size: 13px;">地铁方式：地铁1号线（文泽路方向），在九和路站B1出口向前1.7公里</div>',
                visible: true
            },
            plugin: {
                pName: "Scale",
                events: {
                    init(instance) {
                        console.log(instance);
                    }
                }
            }
        }
    },
    components: {
        commHead,
        footCpright,
    },
    created() { },
    methods: {}
}
</script>

<style lang="scss" scoped>
.container {
    overflow-y: auto;
    & .head_bg {
        height: 300px;
        background-image: url("../assets/images/banner_con.png");
        position: relative;
        & .head_con {
            width:1200px;
            position: absolute;
            top:200px;
            left:50%;
            transform: translateX(-50%);
            & h1 {
                color: #fff;
                margin-bottom: 10px;
            }
            & div {
                width: 80px;
                height: 4px;
                background-color: #fff;
            }
        }
    }
    & .bg_w {
        background-color: #fff;
        padding-top: 64px;

        & > div {
            width: 1200px;
            margin: 0 auto;
            & > h1 {
                margin-bottom: 32px;
            }
            & p {
                font-size: 18px;
                color: #666666;
                letter-spacing: 0;
                line-height: 32px;
            }
            & > p:nth-child(6) {
                margin-bottom: 80px;
            }

            & .qrcode {
                height: 210px;
                display: flex;
                & > div {
                    width: 130px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    & > img {
                        margin-bottom: 16px;
                    }
                }
                & > div:first-child {
                    margin-right: 40px;
                }
            }
        }
    }
    & .map {
        width: 100%;
        height: 550px;
    }
}
</style>